module.exports = __webpack_public_path__ + "static/img/headerbg.c0d08f5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/headerbg.png
// module id = 4Z+u
// module chunks = 0